import { render, staticRenderFns } from "./MobileSettingsAction.vue?vue&type=template&id=37e9d164&scoped=true"
import script from "./MobileSettingsAction.vue?vue&type=script&lang=js"
export * from "./MobileSettingsAction.vue?vue&type=script&lang=js"
import style0 from "./MobileSettingsAction.vue?vue&type=style&index=0&id=37e9d164&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9d164",
  null
  
)

export default component.exports